import { assertNever } from "../../../types/index.ts";
import { SUDO_RUN_COMMAND_SCRIPT, indentString } from "./runCommandScript.ts";

type EscapingMode = "bash" | "none" | "terraform";

export const generateSsmDocumentYaml = (mode: EscapingMode): string => {
  const script =
    mode === "bash"
      ? SUDO_RUN_COMMAND_SCRIPT("\\", "")
      : mode === "terraform"
        ? SUDO_RUN_COMMAND_SCRIPT("", "$")
        : mode === "none"
          ? SUDO_RUN_COMMAND_SCRIPT("", "")
          : assertNever(mode);

  // If you modify the YAML structure here, please also update the corresponding
  // Terraform SSM Document resource by running `yarn generate:ssm-yaml`.
  return `schemaVersion: "2.2"
description: "Grant/revoke password-less sudo access, add/remove an authorized ssh key, or create a user"
parameters:
  UserName:
    type: "String"
    description: "User name"
    allowedPattern: "^[a-z][-a-z0-9_]*$"
  Action:
    type: "String"
    description: "'grant' or 'revoke'"
    allowedValues:
    - cleanup
    - grant
    - revoke
  RequestId:
    type: "String"
    description: "P0 access request identifier"
    allowedPattern: "^[a-zA-Z0-9]*$"
  PublicKey:
    type: "String"
    description: "SSH public key"
    allowedPattern: "^[^'\\n]*$"
    default: "N/A"
  Sudo:
    type: "String"
    description: "Whether to grant sudo access"
    allowedValues:
    - "false"
    - "true"
    default: "false"
mainSteps:
- precondition:
    StringEquals:
      - platformType
      - Linux
  action: aws:runShellScript
  name: InvokeLinuxScript
  inputs:
    runCommand:
      - |
${indentString(script, 8)}
`;
};
